export const UNAUTHORIZED = 401;
export const BAD_REQUEST = 400;
export const SERVER_EXCEPTION = 500;
export const NOT_FOUND = 404;
export const GATEWAY_TIMEOUT = 504;
